import { render } from "./HeaderTwitter.vue?vue&type=template&id=6f4bf396"
import script from "./HeaderTwitter.vue?vue&type=script&lang=js"
export * from "./HeaderTwitter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__